// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2iEzO","label":"Radio_label__2XQZ9","checkMark":"Radio_checkMark__2ZbTH","disabled":"Radio_disabled___seir"};